import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SaveAllConfirmationDialogData {
  pendingChanges: Array<{
    segIndex: string;
    changes: Array<{
      action: 'add' | 'delete' | 'update';
      mapping: { xmlPath: string, condition: string, hl7Path: string };
      originalMapping?: { xmlPath: string, condition: string, hl7Path: string };
    }>;
  }>;
  summary: {
    addCount: number;
    deleteCount: number;
    updateCount: number;
    segmentCount: number;
  };
  getAliasForMapping?: (xmlPath: string) => string;
}

@Component({
  selector: 'app-save-all-confirmation-dialog',
  templateUrl: './save-all-confirmation-dialog.component.html',
  styleUrls: ['./save-all-confirmation-dialog.component.scss']
})
export class SaveAllConfirmationDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SaveAllConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaveAllConfirmationDialogData
  ) {}

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  getAlias(xmlPath: string): string {
    if (this.data.getAliasForMapping) {
      return this.data.getAliasForMapping(xmlPath);
    }
    // Fallback: extract last part of path
    const parts = xmlPath.split('/');
    return parts[parts.length - 1] || xmlPath;
  }

  getActionLabel(action: string): string {
    switch (action) {
      case 'add': return 'Add';
      case 'delete': return 'Delete';
      case 'update': return 'Update';
      default: return action;
    }
  }

  getActionClass(action: string): string {
    switch (action) {
      case 'add': return 'badge-success';
      case 'delete': return 'badge-danger';
      case 'update': return 'badge-warning';
      default: return 'badge-secondary';
    }
  }
}

